// import { useEffect, useState } from 'react'
// import { GroupService, PaginationType } from 'utility'
// import { LoaderBar, FlexRowBetween, PageHeader } from 'components'
// import { AppPrimaryButton } from 'elements'
// import { useNavigate } from 'react-router-dom'
// import {
//     CapaGroupList,
//     AddGroupModal,
//     GroupCapaAddEditModal,
// } from 'page-components'
// import { GetTeamGroupCapa, GetTempleteList } from 'hooks'
// import styled from 'styled-components'
// import { DesktopMode, MobileMode } from 'layout'

// const GroupedScreenContainer = styled.div`
//     .error {
//         color: ${({ theme }) => theme.colors.danger};
//     }
// `

// export const CapaListPage = () => {
//     const [filter, setFilter] = useState({
//         PageNumber: 1,
//         PageSize: 10, // Default page size
//         IsCapa: true, // Filter to show only CAPA groups
//     })
//     const navigate = useNavigate()
//     const [capaList, setCapaList] = useState([])
//     const { options: templateOptions } = GetTempleteList(PaginationType.All)
//     console.log(GetTempleteList(PaginationType.All))
//     // eslint-disable-next-line no-unused-vars
//     const { data, loading, totalCount } = GetTeamGroupCapa(filter)
//     const {
//         setData: setGroupDropDown,
//         options: groupOptions,
//         data: groupDataList,
//         refresh: allRefresh,
//     } = GetTeamGroupCapa()
//     // console.log("group options ",groupOptions)
//     // const groupOptions = [{ label: 1, value: 1 }, { label: 154, value: 154 } ,{ label: 156, value: 156 }]
//     useEffect(() => {
//         console.log('🔍 groupDataList in CapaListPage:', groupDataList)
//     }, [groupDataList])
//     const [openAddGroup, setOpenAddGroup] = useState(false)
//     const [addGroupModal, setAddGroupModal] = useState(false)
//     const [processing, setProcessing] = useState('')
//     // const [capaGroup, setCapaGroup] = useState({})
//     const addGroupMembersAndClose = async groupMemberData => {
//         try {
//             if (groupMemberData) {
//                 setProcessing('Processing')
//                 await GroupService.addGroupMembers(groupMemberData)
//             }
//             // listrefresh()
//             allRefresh()
//         } catch {
//             // setError(DefaultText.Default)
//         } finally {
//             setOpenAddGroup(false)
//             setProcessing('')
//             setAddGroupModal({})
//             navigate(``)
//         }
//     }

//     // Fetch CAPA groups on filter change
//     useEffect(() => {
//         const fetchCapaList = async () => {
//             try {
//                 const result = await GroupService.getTeamGroupCapa(filter)
//                 // console.log('CAPA Data:', result)
//                 setCapaList(result)
//             } catch (err) {
//                 // console.error('Error processing CAPA:', err)
//             }
//         }

//         fetchCapaList()
//     }, [filter])

//     // Handle page change
//     const pageChanged = pageNumber => {
//         setFilter(prevFilter => ({
//             ...prevFilter,
//             PageNumber: pageNumber,
//         }))
//     }

//     // Remove function for CAPA group
//     const remove = groupId => {
//         console.log('Remove group with ID:', groupId)
//     }

//     // Rename function for CAPA group
//     const onRename = groupId => {
//         console.log('Rename group with ID:', groupId)
//         setOpenAddGroup(true)
//         setAddGroupModal(groupId)
//     }

//     // Assign users to CAPA group
//     // const onAssignUsers = groupId => {
//     //     console.log('Assign users to group with ID:', groupId)
//     //     setCapaGroup(groupId)
//     // }
//     const onAssignUsers = data => {
//         navigate(`?id=${data.GroupId}`)
//     }

//     const closeAddGroup = async groupData => {
//         try {
//             if (groupData) {
//                 if (addGroupModal.GroupId) {
//                     setProcessing('Processing')
//                     const result = await GroupService.update(groupData)
//                     const list = data.map(ele => {
//                         if (ele.GroupId === addGroupModal.GroupId) {
//                             return result
//                         }
//                         return ele
//                     })
//                     // setData(list)
//                     setGroupDropDown(list)
//                 } else {
//                     setProcessing('Processing')
//                     const result = await GroupService.add(groupData)
//                     // setData([...data, result])
//                     setGroupDropDown([...data, result])
//                 }
//             }
//         } catch {
//             // setError(DefaultText.Default)
//         } finally {
//             setOpenAddGroup(false)
//             setProcessing('')
//             setAddGroupModal({})
//         }
//     }

//     return (
//         <GroupedScreenContainer>
//             <DesktopMode>
//                 <FlexRowBetween>
//                     <PageHeader header="CAPA List" />
//                     <div>
//                         <AppPrimaryButton onClick={() => setOpenAddGroup(true)}>
//                             {' '}
//                             Create Group
//                         </AppPrimaryButton>

//                         <AppPrimaryButton onClick={() => navigate(-1)}>
//                             Back
//                         </AppPrimaryButton>
//                     </div>
//                 </FlexRowBetween>
//             </DesktopMode>
//             <MobileMode>
//                 <FlexRowBetween>
//                     <PageHeader header="CAPA List" />
//                     <div>
//                         <AppPrimaryButton onClick={() => setOpenAddGroup(true)}>
//                             {' '}
//                             Create Group
//                         </AppPrimaryButton>

//                         <AppPrimaryButton onClick={() => navigate(-1)}>
//                             Back
//                         </AppPrimaryButton>
//                     </div>
//                 </FlexRowBetween>
//             </MobileMode>
//             <AddGroupModal
//                 data={addGroupModal}
//                 loading={processing}
//                 open={openAddGroup}
//                 onClose={closeAddGroup}
//             />

//             <div>
//                 <GroupCapaAddEditModal
//                     groupOptions={groupOptions}
//                     // setCapa={capaGroup}
//                     // customerOptions={customerOptions}
//                     templateOptions={templateOptions}
//                     // userseOptions={userseOptions}
//                     onSubmit={addGroupMembersAndClose}
//                     // error={error}
//                     groupDataList={groupDataList}
//                 />
//             </div>
//             <div className="my-3">
//                 {(processing || loading) && (
//                     <LoaderBar content={processing || 'Loading'} />
//                 )}
//                 <CapaGroupList
//                     data={capaList?.Records || []}
//                     pageChanged={pageChanged}
//                     totalCount={capaList?.TotalCount || 0}
//                     filter={filter}
//                     remove={remove}
//                     onRename={onRename}
//                     onAssign={onAssignUsers}
//                 />
//             </div>
//         </GroupedScreenContainer>
//     )
// }
import { useEffect, useState } from 'react'
import { GroupService } from 'utility'
import { LoaderBar, FlexRowBetween, PageHeader } from 'components'
import { AppPrimaryButton } from 'elements'
import { useNavigate } from 'react-router-dom'
import {
    CapaGroupList,
    AddGroupModal,
    // GroupCapaAddEditModal,
} from 'page-components'
import { GetGroupList } from 'hooks'
import styled from 'styled-components'
import { DesktopMode, MobileMode } from 'layout'

const GroupedScreenContainer = styled.div`
    .error {
        color: ${({ theme }) => theme.colors.danger};
    }
`

export const CapaListPage = () => {
    const [filter, setFilter] = useState({
        PageNumber: 1,
        PageSize: 10,
        IsCapa: true, // Filter to show only CAPA groups
    })
    const navigate = useNavigate()
    const { data, loading, totalCount } = GetGroupList(filter)
    // const { options: templateOptions } = GetTempleteList(PaginationType.All)

    const [capaList, setCapaList] = useState([])

    useEffect(() => {
        if (data) {
            setCapaList(data.filter(group => group.IsCapa === true))
        }
    }, [data])

    const [openAddGroup, setOpenAddGroup] = useState(false)
    const [addGroupModal, setAddGroupModal] = useState(false)
    const [processing, setProcessing] = useState('')

    const onRename = groupId => {
        console.log('Rename group with ID:', groupId)
        setOpenAddGroup(true)
        setAddGroupModal(groupId)
    }

    const onAssignUsers = data => {
        navigate(`?id=${data.GroupId}`)
    }

    const closeAddGroup = async groupData => {
        try {
            if (groupData) {
                setProcessing('Processing')
                await GroupService.update(groupData)
            }
        } catch {
            // Handle error
        } finally {
            setOpenAddGroup(false)
            setProcessing('')
            setAddGroupModal({})
        }
    }

    return (
        <GroupedScreenContainer>
            <DesktopMode>
                <FlexRowBetween>
                    <PageHeader header="CAPA List" />
                    <div>
                        <AppPrimaryButton onClick={() => setOpenAddGroup(true)}>
                            {' '}
                            Create Group
                        </AppPrimaryButton>
                        <AppPrimaryButton onClick={() => navigate(-1)}>
                            Back
                        </AppPrimaryButton>
                    </div>
                </FlexRowBetween>
            </DesktopMode>
            <MobileMode>
                <FlexRowBetween>
                    <PageHeader header="CAPA List" />
                    <div>
                        <AppPrimaryButton onClick={() => setOpenAddGroup(true)}>
                            {' '}
                            Create Group
                        </AppPrimaryButton>
                        <AppPrimaryButton onClick={() => navigate(-1)}>
                            Back
                        </AppPrimaryButton>
                    </div>
                </FlexRowBetween>
            </MobileMode>
            <AddGroupModal
                data={addGroupModal}
                loading={processing}
                open={openAddGroup}
                onClose={closeAddGroup}
            />
            <div className="my-3">
                {(processing || loading) && (
                    <LoaderBar content={processing || 'Loading'} />
                )}
                <CapaGroupList
                    data={capaList.slice(0, filter.PageSize)}
                    pageChanged={page =>
                        setFilter(prev => ({ ...prev, PageNumber: page }))
                    }
                    totalCount={totalCount}
                    filter={filter}
                    remove={() => {}}
                    onRename={onRename}
                    onAssign={onAssignUsers}
                />
            </div>
        </GroupedScreenContainer>
    )
}
